import React, { useEffect } from "react";
import "./css/PrivacyPolicy.css";

import Navbar from "./components/Navbar";
import Newsletter from "./components/NewsLetter";
import Footer from "./components/Footer";

function PrivacyPolicy() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="page-wrapper">

            <div className="privacy-policy-page">

                <div className="container py-5">

                    <div className="row justify-content-center">

                        <Navbar />

                        <div className="col-lg-10">

                            {/* Page Header */}
                            <div className="privacy-header text-center mb-5">

                                <h1 className="privacy-title">
                                    Privacy Policy
                                </h1>

                                <p className="privacy-subtitle">
                                    Fixovera Pvt Ltd
                                </p>

                                <p className="mt-2 text-muted">
                                    Household Services Digital Marketplace
                                </p>

                            </div>


                            {/* Policy Content */}
                            <div className="privacy-card p-4 p-md-5 shadow-sm">

                                {/* Introduction */}
                                <h3>Introduction</h3>

                                <p className="lead-text">
                                    Fixovera Pvt Ltd ("Fixovera", "we", "us",
                                    or "our") operates a household services
                                    digital marketplace that connects
                                    customers with service professionals for
                                    home cleaning, plumbing, electrical
                                    services, AC and appliance services,
                                    painting and home renovation, carpentry,
                                    pest control, and other related household
                                    services.
                                </p>

                                <p>
                                    This Privacy Policy explains how Fixovera
                                    collects, uses, stores, protects, and
                                    shares information when you access or use
                                    our website, mobile applications,
                                    services, and related digital platforms
                                    (collectively, the "Services").
                                </p>

                                <p>
                                    This policy should be read together with
                                    Fixovera's Terms of Service and any
                                    permission-specific privacy notices
                                    presented within the App.
                                </p>

                                <p>
                                    By accessing or using the Fixovera
                                    Services, you acknowledge that you have
                                    read and understood this Privacy Policy.
                                    Where consent is required by applicable
                                    law, we will obtain your consent before
                                    processing the relevant information.
                                </p>


                                <hr className="section-divider" />


                                {/* 1 */}
                                <h3>1. Information We Collect</h3>

                                <p>
                                    Depending on how you use Fixovera, we may
                                    collect the following categories of
                                    information:
                                </p>

                                <ul>

                                    <li>
                                        <strong>Account Information:</strong>
                                        {" "}name, email address, phone number,
                                        profile information, and account
                                        credentials.
                                    </li>

                                    <li>
                                        <strong>Booking Information:</strong>
                                        {" "}service type, service address,
                                        preferred schedule, booking status,
                                        service requirements, and related
                                        transaction information.
                                    </li>

                                    <li>
                                        <strong>Payment Information:</strong>
                                        {" "}transaction details and payment
                                        status processed through authorised
                                        payment service providers.
                                    </li>

                                    <li>
                                        <strong>Location Information:</strong>
                                        {" "}GPS coordinates, approximate
                                        location, service address, and
                                        location information required for
                                        booking and service delivery.
                                    </li>

                                    <li>
                                        <strong>Camera Information:</strong>
                                        {" "}photos or other media that you
                                        voluntarily capture or upload through
                                        the App.
                                    </li>

                                    <li>
                                        <strong>Contact Information:</strong>
                                        {" "}selected contact information
                                        when you voluntarily use a feature
                                        requiring access to your device
                                        contacts.
                                    </li>

                                    <li>
                                        <strong>Device Information:</strong>
                                        {" "}device model, operating system,
                                        application version, IP address,
                                        device identifiers, browser
                                        information, and technical logs.
                                    </li>

                                    <li>
                                        <strong>Communication Information:</strong>
                                        {" "}messages, support requests,
                                        feedback, complaints, and other
                                        communications sent to Fixovera.
                                    </li>

                                    <li>
                                        <strong>Service Professional Information:</strong>
                                        {" "}where applicable, identity,
                                        professional, service category,
                                        verification, availability, and
                                        operational information required for
                                        onboarding and service delivery.
                                    </li>

                                </ul>


                                <hr className="section-divider" />


                                {/* 2 */}
                                <h3>2. How We Use Your Information</h3>

                                <p>
                                    We use information collected through the
                                    Services for legitimate business and
                                    service-related purposes, including:
                                </p>

                                <ul>

                                    <li>
                                        Creating and managing your Fixovera
                                        account.
                                    </li>

                                    <li>
                                        Processing and managing service
                                        bookings.
                                    </li>

                                    <li>
                                        Connecting customers with suitable
                                        service professionals.
                                    </li>

                                    <li>
                                        Enabling service professionals to
                                        locate and reach the service address.
                                    </li>

                                    <li>
                                        Providing live booking and service
                                        status updates.
                                    </li>

                                    <li>
                                        Processing payments and maintaining
                                        transaction records.
                                    </li>

                                    <li>
                                        Verifying service completion.
                                    </li>

                                    <li>
                                        Resolving disputes, complaints, and
                                        service-related issues.
                                    </li>

                                    <li>
                                        Detecting and preventing fraud,
                                        misuse, and security incidents.
                                    </li>

                                    <li>
                                        Improving platform functionality,
                                        service availability, and customer
                                        experience.
                                    </li>

                                    <li>
                                        Providing customer support and
                                        responding to enquiries.
                                    </li>

                                    <li>
                                        Complying with applicable legal,
                                        regulatory, and law-enforcement
                                        requirements.
                                    </li>

                                </ul>


                                <hr className="section-divider" />


                                {/* 3 */}
                                <h3>3. Mobile GPS Location Access</h3>

                                <p>
                                    Location access enables Fixovera to
                                    connect customers with nearby service
                                    professionals, provide accurate
                                    service-area matching, calculate travel
                                    time and applicable distance-based
                                    charges, and improve service reliability.
                                </p>

                                <h4>Location Data We May Collect</h4>

                                <ul>

                                    <li>
                                        Precise GPS coordinates
                                        (latitude/longitude) when authorised.
                                    </li>

                                    <li>
                                        Approximate location derived from IP
                                        address or network signals when GPS
                                        information is unavailable.
                                    </li>

                                    <li>
                                        Address details manually entered by
                                        you for service bookings.
                                    </li>

                                </ul>

                                <h4>How We Use Location Data</h4>

                                <ul>

                                    <li>
                                        To identify service professionals
                                        available in your area.
                                    </li>

                                    <li>
                                        To help professionals navigate to
                                        your service address.
                                    </li>

                                    <li>
                                        To verify service completion at the
                                        appropriate location.
                                    </li>

                                    <li>
                                        To calculate distance, estimated
                                        arrival times, and service-area
                                        eligibility.
                                    </li>

                                    <li>
                                        To detect potentially fraudulent
                                        bookings and improve platform safety.
                                    </li>

                                    <li>
                                        To generate aggregated and
                                        anonymised operational analytics.
                                    </li>

                                </ul>

                                <h4>Consent and Control</h4>

                                <p>
                                    Fixovera requests location permission
                                    through your device's permission system.
                                    You may grant, deny, or withdraw location
                                    access through your device settings.
                                    Certain features may not function if
                                    location access is disabled.
                                </p>

                                <p>
                                    We do not access precise location data
                                    without the applicable permission being
                                    granted, except where otherwise permitted
                                    by applicable law.
                                </p>


                                <hr className="section-divider" />


                                {/* 4 */}
                                <h3>4. Camera Access</h3>

                                <p>
                                    Camera access enables customers and
                                    service professionals to document service
                                    requirements, upload relevant photographs,
                                    document completed work, and support
                                    service-related communication.
                                </p>

                                <h4>Camera Data We May Collect</h4>

                                <ul>

                                    <li>
                                        Photos describing a service issue,
                                        such as damaged appliances or
                                        plumbing problems.
                                    </li>

                                    <li>
                                        Before-and-after photographs of
                                        completed work, where applicable.
                                    </li>

                                    <li>
                                        Profile photographs.
                                    </li>

                                    <li>
                                        Photographs used for identity or
                                        professional verification where
                                        applicable.
                                    </li>

                                </ul>

                                <h4>How We Use Camera Data</h4>

                                <ul>

                                    <li>
                                        To help professionals understand
                                        service requirements.
                                    </li>

                                    <li>
                                        To document service completion.
                                    </li>

                                    <li>
                                        To investigate service disputes or
                                        complaints.
                                    </li>

                                    <li>
                                        To support identity and trust
                                        verification processes.
                                    </li>

                                </ul>

                                <p>
                                    Fixovera does not access your camera
                                    without your active initiation of a
                                    photo or video capture action within the
                                    App. We do not access your camera roll
                                    beyond images you explicitly select to
                                    upload.
                                </p>


                                <hr className="section-divider" />


                                {/* 5 */}
                                <h3>5. Live Tracking Access</h3>

                                <p>
                                    Fixovera may provide live tracking during
                                    an active service booking to allow
                                    customers to view the real-time location
                                    and estimated arrival of an assigned
                                    service professional.
                                </p>

                                <h4>Live Tracking Data</h4>

                                <ul>

                                    <li>
                                        Real-time GPS location of the assigned
                                        service professional during an active
                                        booking.
                                    </li>

                                    <li>
                                        Booking journey timestamps such as
                                        accepted, en route, arrived, started,
                                        and completed.
                                    </li>

                                    <li>
                                        Estimated and actual travel routes
                                        and duration.
                                    </li>

                                </ul>

                                <h4>How We Use Live Tracking</h4>

                                <ul>

                                    <li>
                                        To display the professional's
                                        location and estimated arrival time.
                                    </li>

                                    <li>
                                        To support safe and timely service
                                        delivery.
                                    </li>

                                    <li>
                                        To investigate complaints, disputes,
                                        or safety incidents.
                                    </li>

                                    <li>
                                        To improve operational efficiency
                                        through aggregated analytics.
                                    </li>

                                </ul>

                                <p>
                                    Live tracking is generally active only
                                    during the relevant assigned booking.
                                    Service professionals are informed that
                                    their location may be shared with the
                                    customer during an active service.
                                </p>


                                <hr className="section-divider" />


                                {/* 6 */}
                                <h3>6. Contact Access</h3>

                                <p>
                                    Fixovera may request access to your device
                                    contacts for optional, user-initiated
                                    features such as referrals, sharing
                                    booking information, or adding an
                                    alternate contact for a service booking.
                                </p>

                                <h4>Contact Information We May Access</h4>

                                <ul>

                                    <li>
                                        Names and phone numbers from selected
                                        device contacts.
                                    </li>

                                    <li>
                                        Contact details required to complete
                                        a specific referral or sharing action.
                                    </li>

                                </ul>

                                <p>
                                    Fixovera does not automatically or
                                    continuously access your entire contact
                                    list. Contact access occurs only when you
                                    voluntarily initiate a feature requiring
                                    that permission.
                                </p>

                                <p>
                                    You may deny contact access and continue
                                    using the core Fixovera booking and
                                    service features. Only features requiring
                                    contact information may become
                                    unavailable.
                                </p>


                                <hr className="section-divider" />


                                {/* 7 */}
                                <h3>7. Service Professional Information</h3>

                                <p>
                                    Service professionals who use Fixovera
                                    may be required to provide additional
                                    information for account creation,
                                    verification, service delivery, and
                                    marketplace operations.
                                </p>

                                <p>
                                    This may include identity information,
                                    contact information, service categories,
                                    professional details, documents,
                                    photographs, availability, location
                                    information, booking history, ratings,
                                    and other information reasonably required
                                    to operate the professional platform.
                                </p>


                                <hr className="section-divider" />


                                {/* 8 */}
                                <h3>8. Payments and Transactions</h3>

                                <p>
                                    Payments made through Fixovera may be
                                    processed by authorised third-party
                                    payment service providers.
                                </p>

                                <p>
                                    Fixovera may receive transaction-related
                                    information such as payment status,
                                    transaction reference numbers, amount,
                                    date, and related billing information.
                                    Payment credentials such as complete
                                    card numbers may be handled directly by
                                    the applicable payment provider and not
                                    stored by Fixovera except where permitted
                                    and necessary for the applicable service.
                                </p>


                                <hr className="section-divider" />


                                {/* 9 */}
                                <h3>9. Sharing of Information</h3>

                                <p>
                                    Fixovera does not sell your personal
                                    information to third parties. Information
                                    may be shared only where reasonably
                                    necessary for operating the Services or
                                    where permitted or required by law.
                                </p>

                                <ul>

                                    <li>
                                        With the service professional
                                        assigned to your booking, strictly
                                        for service delivery.
                                    </li>

                                    <li>
                                        With customers and professionals
                                        involved in the relevant booking.
                                    </li>

                                    <li>
                                        With cloud, hosting, infrastructure,
                                        payment, communication, mapping, and
                                        other service providers processing
                                        information on our behalf.
                                    </li>

                                    <li>
                                        With law enforcement or regulatory
                                        authorities where required by law or
                                        valid legal process.
                                    </li>

                                    <li>
                                        Where necessary to protect the
                                        safety, rights, property, or security
                                        of Fixovera, users, or the public.
                                    </li>

                                    <li>
                                        In connection with a merger,
                                        acquisition, restructuring, or sale
                                        of business assets, subject to
                                        appropriate privacy protections.
                                    </li>

                                </ul>


                                <hr className="section-divider" />


                                {/* 10 */}
                                <h3>10. Data Security</h3>

                                <p>
                                    Fixovera takes reasonable technical and
                                    organisational measures to protect
                                    personal information against unauthorised
                                    access, loss, misuse, alteration, or
                                    disclosure.
                                </p>

                                <ul>

                                    <li>
                                        Encryption of information in transit
                                        where appropriate.
                                    </li>

                                    <li>
                                        Appropriate protection of information
                                        stored on our systems.
                                    </li>

                                    <li>
                                        Role-based access controls.
                                    </li>

                                    <li>
                                        Restricted access to authorised
                                        personnel and service providers.
                                    </li>

                                    <li>
                                        Security monitoring and periodic
                                        reviews.
                                    </li>

                                </ul>

                                <p>
                                    However, no internet-based system or
                                    electronic storage system can be
                                    guaranteed to be completely secure.
                                </p>


                                <hr className="section-divider" />


                                {/* 11 */}
                                <h3>11. Data Retention</h3>

                                <p>
                                    Fixovera retains personal information only
                                    for as long as reasonably necessary to
                                    provide the Services, maintain business
                                    and transaction records, resolve disputes,
                                    investigate security incidents, comply
                                    with legal obligations, and enforce our
                                    agreements.
                                </p>

                                <p>
                                    Booking-related location, tracking,
                                    communication, and uploaded media may be
                                    retained for a limited period after
                                    completion of the booking where necessary
                                    for dispute resolution, safety
                                    investigations, accounting, or legal
                                    compliance.
                                </p>

                                <p>
                                    When information is no longer required,
                                    it may be securely deleted or anonymised
                                    in accordance with our applicable
                                    retention practices.
                                </p>


                                <hr className="section-divider" />


                                {/* 12 */}
                                <h3>12. Cookies and Similar Technologies</h3>

                                <p>
                                    Our website and digital services may use
                                    cookies and similar technologies to
                                    maintain sessions, remember preferences,
                                    understand usage patterns, improve
                                    performance, and support relevant
                                    functionality.
                                </p>

                                <p>
                                    You may configure your browser to refuse
                                    certain cookies. Disabling cookies may
                                    affect the availability or functionality
                                    of some website features.
                                </p>


                                <hr className="section-divider" />


                                {/* 13 */}
                                <h3>13. Third-Party Links and Services</h3>

                                <p>
                                    Fixovera may provide links or integrations
                                    to third-party websites and services,
                                    including payment, mapping, communication,
                                    or other service providers.
                                </p>

                                <p>
                                    Third-party services operate under their
                                    own privacy policies and terms. Fixovera
                                    is not responsible for the privacy
                                    practices of independent third-party
                                    services.
                                </p>


                                <hr className="section-divider" />


                                {/* 14 */}
                                <h3>14. User Rights and Choices</h3>

                                <p>
                                    Subject to applicable law, you may have
                                    the right to:
                                </p>

                                <ul>

                                    <li>
                                        Request access to personal
                                        information held about you.
                                    </li>

                                    <li>
                                        Request correction of inaccurate or
                                        incomplete information.
                                    </li>

                                    <li>
                                        Request deletion of personal
                                        information, subject to applicable
                                        legal and operational requirements.
                                    </li>

                                    <li>
                                        Withdraw consent for permissions such
                                        as location, camera, or contacts
                                        through your device settings.
                                    </li>

                                    <li>
                                        Request information regarding how
                                        your personal information is
                                        processed.
                                    </li>

                                    <li>
                                        Raise privacy-related concerns or
                                        complaints with Fixovera.
                                    </li>

                                </ul>


                                <hr className="section-divider" />


                                {/* 15 */}
                                <h3>15. Withdrawal of Permission</h3>

                                <p>
                                    You may withdraw permissions granted to
                                    the Fixovera App through your device
                                    settings.
                                </p>

                                <p>
                                    Disabling a permission may affect certain
                                    features. For example, disabling location
                                    access may affect location-based service
                                    matching, while disabling camera access
                                    may prevent you from uploading service
                                    photographs.
                                </p>


                                <hr className="section-divider" />


                                {/* 16 */}
                                <h3>16. Children's Privacy</h3>

                                <p>
                                    Fixovera is a household services platform
                                    and is not specifically directed toward
                                    children. Users should not provide
                                    personal information belonging to a child
                                    through the Services unless they are
                                    legally authorised to do so.
                                </p>


                                <hr className="section-divider" />


                                {/* 17 */}
                                <h3>17. Communications</h3>

                                <p>
                                    Fixovera may contact you through email,
                                    phone calls, SMS, WhatsApp, push
                                    notifications, or in-app notifications
                                    regarding account activity, bookings,
                                    service updates, payments, security
                                    matters, support requests, and other
                                    service-related communications.
                                </p>

                                <p>
                                    Where required by applicable law, we will
                                    obtain appropriate consent for promotional
                                    communications and provide applicable
                                    opt-out mechanisms.
                                </p>


                                <hr className="section-divider" />


                                {/* 18 */}
                                <h3>18. Changes to This Privacy Policy</h3>

                                <p>
                                    Fixovera may update this Privacy Policy
                                    from time to time to reflect changes in
                                    our Services, technology, legal
                                    requirements, or business practices.
                                </p>

                                <p>
                                    Updated versions will be published through
                                    the applicable Fixovera website or
                                    application. Your continued use of the
                                    Services after an updated policy becomes
                                    effective constitutes acceptance of the
                                    updated policy to the extent permitted by
                                    applicable law.
                                </p>


                                <hr className="section-divider" />


                                {/* 19 */}
                                <h3>19. Permission-Specific Privacy Policies</h3>

                                <p>
                                    Fixovera maintains permission-specific
                                    privacy notices for certain mobile
                                    application permissions and features,
                                    including:
                                </p>

                                <ul>

                                    <li>
                                        Mobile GPS Location Access
                                    </li>

                                    <li>
                                        Camera Access
                                    </li>

                                    <li>
                                        Live Tracking Access
                                    </li>

                                    <li>
                                        Contact Access
                                    </li>

                                </ul>

                                <p>
                                    These notices explain the specific
                                    information collected through each
                                    permission, why it is required, how it is
                                    used, how long it may be retained, and
                                    how users can control the permission.
                                </p>


                                <hr className="section-divider" />


                                {/* 20 */}
                                <h3>20. Contact Us</h3>

                                <p>
                                    If you have questions, requests,
                                    complaints, or concerns regarding this
                                    Privacy Policy or the processing of your
                                    personal information, you can contact
                                    Fixovera using the following details:
                                </p>

                                <ul className="privacy-contact-list">

                                    <li>
                                        <strong>Company:</strong>{" "}
                                        Fixovera Pvt Ltd
                                    </li>

                                    <li>
                                        <strong>Email:</strong>{" "}
                                        <a href="mailto:privacy@fixovera.com">
                                            privacy@fixovera.com
                                        </a>
                                    </li>

                                    <li>
                                        <strong>In-App:</strong>{" "}
                                        Settings &gt; Help &amp; Support &gt;
                                        Privacy Queries
                                    </li>

                                    <li>
                                        <strong>Registered Office:</strong>
                                        <br />
                                        Fixovera Pvt Ltd
                                        <br />
                                        392, Ranikuthir
                                        <br />
                                        Apurbapur
                                        <br />
                                        Singur
                                        <br />
                                        West Bengal - 712409
                                    </li>

                                </ul>


                                <div className="mt-5 p-4 rounded-3 bg-light">

                                    <h4>
                                        Permission Privacy Notice
                                    </h4>

                                    <p className="mb-0">
                                        By using Fixovera's mobile
                                        application, you may be asked to
                                        provide permissions for features such
                                        as location, camera, live tracking,
                                        and contacts. You can manage these
                                        permissions through your device
                                        settings. Certain permissions are
                                        required only for specific features
                                        and are not required for basic
                                        browsing or all booking functions.
                                    </p>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>


            <Newsletter />

            <Footer />

        </div>
    );
}

export default PrivacyPolicy;